import { DateOnly } from "shared/request/myHealthyAdvantageApi";
import "shared/extensions/date";

export const formatExportFilename = (dateFrom: DateOnly, dateTo: DateOnly): string => {
  return `${Date.fromDateOnly(dateFrom)?.toDateOnlyString()} - ${Date.fromDateOnly(dateTo)?.toDateOnlyString()}`;
};
